import { Redirect } from 'expo-router';

import { StartMembership } from '../../auth/components/start-membership/StartMembership';
import { FRUITFUL_ENV } from '../../config/config';

export default function StartMembershipScreen() {
    return FRUITFUL_ENV === 'production' ? (
        <Redirect href="/sign-up/get-started" />
    ) : (
        <StartMembership />
    );
}
